module.exports = __webpack_public_path__ + "img/52.1e624a03.png";